<template>
    <div class="list--view responsive-element">

        <div data-toggle="tooltip" data-placement="top" title="Filtra per anagrafiche attive o storiche"
            class="single--list-view single--list-view-employees">
            <span class="pre-filter-label"> Filtri</span>
            <vs-select class="selectExample" v-model="selectTypePerson" @input="statusSelected">
                <vs-select-item :is-selected="item.isSelected" :key="index" :value="item.value" :text="item.label"
                    v-for="(item, index) in optionsTypePerson" />
            </vs-select>
        </div>

        <!-- Pay Item Filter - Only visible if configuration is enabled -->
        <div v-if="advancedFiltersEnabled" data-toggle="tooltip" data-placement="top" title="Filtra per voce di costo"
            class="single--list-view single--list-view-roles">
            <vs-select class="selectExample" v-model="selectPayItem" @input="payItemSelected">
                <vs-select-item :is-selected="item.isSelected" :key="index" :value="item.value" :text="item.label"
                    v-for="(item, index) in optionsPayItems" />
            </vs-select>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                selectTypePerson: this.getSelectedTypePerson(),
                optionsTypePerson:[

                    {value: '0', label: this.__("misc.actuals"), isSelected: true },
                    {value: '1', label: this.__("misc.history"), isSelected: false },
                ],
                selectPayItem: this.getSelectedPayItem(),
                optionsPayItems: [],
                advancedFiltersEnabled: false,
            }
        },
        methods: {
          getSelectedTypePerson(){
            let resignedValue = '0';
            if (location.search.indexOf("resigned") >= 0 ){
              resignedValue = (/resigned=([^&]+)/.exec(location.href)[1] === "1") ? '1' : '0';
            }
            return resignedValue;
          },
          getSelectedPayItem(){
            let payItemValue = '';
            if (location.search.indexOf("pay_item_id") >= 0 ){
              payItemValue = /pay_item_id=([^&]+)/.exec(location.href)[1];
            }
            return payItemValue;
          },
          statusSelected(selectedOption, id) {

              if (selectedOption === 'all') {
                location.href = app.__vue__.removeParam("resigned");
              } else if (selectedOption == "1") {
                location.href = app.__vue__.addParam("resigned", "1");
              } else if (selectedOption == "0") {
                  location.href = app.__vue__.addParam("resigned", "0");
              }
            },
          payItemSelected(selectedOption, id) {
              if (selectedOption) {
                location.href = app.__vue__.addParam("pay_item_id", selectedOption);
              }
          },
          loadPayItems(){
              axios
                  .get("/api/pay-items-people/get-pay-items" + location.search)
                  .then(response => {
                      this.optionsPayItems = response.data;
                      // Auto-select first item if none selected
                      if (!this.selectPayItem && this.optionsPayItems.length > 0) {
                          this.selectPayItem = this.optionsPayItems[0].value;
                      }
                  });
          }
        },
        mounted(){
            // Carica il flag advancedFiltersEnabled tramite API
            axios.get('/api/config/advanced-historical-filters')
                .then(response => {
                    this.advancedFiltersEnabled = !!response.data.advancedHistoricalFilters;
                    if (this.advancedFiltersEnabled) {
                        this.loadPayItems();
                    }
                })
                .catch(() => {
                    this.advancedFiltersEnabled = false;
                });
        }

    }
</script>
